import { render, staticRenderFns } from "./MeasureDetailPage.vue?vue&type=template&id=25c796d8&"
import script from "./MeasureDetailPage.vue?vue&type=script&lang=js&"
export * from "./MeasureDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports